import './FormInputCheckbox.scss' ;

import {FormInputRadioButtons} from "root/ReactHookForm/FormComponents/FormInputRadioButtons";
import React from "react";

const FormInputRadioButtonsYesNo = ( { control, required, sectionName, name } ) =>
{
    const yesNoFilters = {
        NO: 0,
        YES: 1,
    }

    const yesNoValues = [
        { offset: yesNoFilters.YES, label: 'Yes'},
        { offset: yesNoFilters.NO, label: 'No'},
    ]

    return (
        <FormInputRadioButtons values={yesNoValues} sectionName={sectionName} name={name} control={control} required={required} />
    )
}

export { FormInputRadioButtonsYesNo };
